import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Button, Message, Modal, Popup } from "semantic-ui-react";
import { ErrorWrap } from "../../helpers/error";
import { StyledTriggerLink } from "./trigger-link";
import { t } from "../../constant/translations";

export const ConfirmModalAction = ({
  header,
  trigger_props,
  action,
  content,
  confirmLabel,
  useTextTrigger,
  textTriggerText,
  loading,
  triggerTooltipText,
  confirmDisabled,
  error,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [errorState, setErrorState] = useState(new ErrorWrap(null));
  const prevLoadingRef = React.useRef(loading);

  useEffect(() => {
    const wasLoading = prevLoadingRef.current;
    prevLoadingRef.current = loading;

    if (wasLoading && error) {
      if (error.exists()) {
        setErrorState(error);
      } else {
        setIsOpen(false);
      }
    }
  }, [loading, error]);

  const handleClose = () => setIsOpen(false);
  const handleOpen = () => {
    setIsOpen(true);
    setErrorState(new ErrorWrap(null));
  };

  const triggerElement = useTextTrigger ? (
    <Popup
      disabled={!triggerTooltipText}
      content={triggerTooltipText}
      trigger={
        <StyledTriggerLink {...trigger_props} onClick={handleOpen}>
          {textTriggerText || t("logActions.reconcile_cap")}
        </StyledTriggerLink>
      }
    />
  ) : (
    <Popup
      disabled={!triggerTooltipText}
      content={triggerTooltipText}
      trigger={<Button basic={true} {...trigger_props} onClick={handleOpen} />}
    />
  );

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      closeOnDimmerClick={!loading}
      trigger={triggerElement}
    >
      {header && <Modal.Header>{header}</Modal.Header>}
      <Modal.Content>
        <p>{content}</p>
        {errorState.exists() && (
          <Message error content={errorState.getGlobal()} />
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button
          icon="remove"
          onClick={handleClose}
          content={t("common.back")}
          disabled={loading}
        />
        <Button
          icon="checkmark"
          onClick={action}
          content={confirmLabel || t("labels.yes")}
          loading={loading}
          disabled={confirmDisabled}
        />
      </Modal.Actions>
    </Modal>
  );
};

// PropTypes for runtime type checking
ConfirmModalAction.propTypes = {
  action: PropTypes.func,
  header: PropTypes.string,
  content: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.instanceOf(ErrorWrap),
  trigger_props: PropTypes.object.isRequired,
  confirmLabel: PropTypes.string,
  useTextTrigger: PropTypes.bool,
  textTriggerText: PropTypes.string,
  triggerTooltipText: PropTypes.string,
  confirmDisabled: PropTypes.bool,
};
